/*global jQuery:false */
'use strict';

var markers = [];
var map;
var emptyBounds;
var isMapLoaded = false;

// Deletes all markers in the array by removing references to them.
function deleteMarkers() {
    for (let i = 0; i < markers.length; i++) {
        if (!!markers[i]) {
            markers[i].map = null;
        }
    }
    markers = [];
    isMapLoaded = false;
}

function clickMarkerById(id) {
    google.maps.event.trigger(markers[id], 'click');
}

var initializeMap = function () {
    emptyBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(44.2645829, -78.812466),
        new google.maps.LatLng(50.7331204, -63.8576864));

    // Make our markers
    var montreal = {
        lat: 45.516672,
        lng: -73.650005
    };

    map = new google.maps.Map(document.getElementById('search-map-container'), {
        zoom: 13,
        center: montreal,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        panControl: false
    });

    map.fitBounds(emptyBounds);
    if (isMapLoaded) {
        displayMarkers();
    } else {
        map.addListener('tilesloaded', displayMarkers);
    }
};

function displayMarkers() {
    if (!isMapLoaded) {
        isMapLoaded = true;
        var bounds = new google.maps.LatLngBounds();
        var count = 0;
        var infoWindow = new google.maps.InfoWindow();
        let bannerName = bannerCode;

        var iconNormal = {
            url: "/images/main/component/store/" + bannerName + "/pin-map.png",
            scaledSize: new google.maps.Size(28, 38),
            labelOrigin: new google.maps.Point(12, 16)
        };
        var iconFavorite = {
            url: "/images/main/component/store/" + bannerName + "/pin-map--favorite.png",
            scaledSize: new google.maps.Size(34, 44),
            labelOrigin: new google.maps.Point(17, 25)
        };
        var iconMetroPlusNormal = {
            url: "/images/main/component/store/" + bannerName + "/pin-map--metro-plus.png",
            scaledSize: new google.maps.Size(31, 38),
            labelOrigin: new google.maps.Point(12, 16)
        };
        var iconMetroPlusFavorite = {
            url: "/images/main/component/store/" + bannerName + "/pin-map--metro-plus-favorite.png",
            scaledSize: new google.maps.Size(36, 44),
            labelOrigin: new google.maps.Point(17, 25)
        };

        jQuery(".find-a-store .fs--box-shop").each(
            function (index, node) {
                count = count + 1;

                var $node = jQuery(node);

                var storeName = $node.data('store-name');
                var iconImageName = $node.data('name-image');

                var latitude = parseFloat($node.data('store-lat'));
                var longitude = parseFloat($node.data('store-lng'));
                var storeId = $node.data('store-id');

                var image;

                if (iconImageName === 'pin-map.png') {
                    image = iconNormal;
                } else if (iconImageName === 'pin-map--favorite.png') {
                    image = iconFavorite;
                } else if (iconImageName === 'pin-map--metro-plus.png') {
                    image = iconMetroPlusNormal;
                } else {
                    image = iconMetroPlusFavorite;
                }

                createMarker(map, image, latitude, longitude, storeName, storeId, bounds, infoWindow);
            });

        let $container = $('#search-map-container');
        $container.on('click', '.setMyStoreButton', onClickSetMyStore);
        $container.on('click', '.info-marker .setMyCommunicationStoreButton', onClickConfirmMyCommunicationStore);

        if (bounds.isEmpty()) {
            map.fitBounds(emptyBounds);
        } else {
            map.fitBounds(bounds);
            if (markers.length === 1) {
                map.setZoom(16);
            }
        }
    }
}

function createMarker(map, image, latitude, longitude, storeName, storeId, bounds, infoWindow) {
    var marker = new google.maps.Marker({
        position: {
            lat: latitude,
            lng: longitude
        },
        map: map,
        title: storeName,
        optimized: false,

        icon: image
    });

    bounds.extend(marker.position);

    marker.addListener('click', function () {
        $.ajax({
            url: findStoreUrl + '/storeDetails/' + storeId,
            type: "PATCH",
            headers: {
                "Accept-Language": lang
            },
            async: false,
            contentType: "application/json; charset=utf-8",
            success: _updateInfoWindowAjaxResponse.bind(infoWindow),
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    _updateInfoWindowAjaxResponse.bind(infoWindow);
                }
            }
        });

        infoWindow.open(map, marker);
    });
    markers.push(marker);
}

function _updateInfoWindowAjaxResponse(data) {
    this.setContent(data + "");
}

function hideMapPlaceholderToDisplayMap() {
    $('#search-all-stores-map-placeholder').hide();
    $('.find-a-store .fs--boxes').show();
}

function initFindStore() {
    const fsContainerId = '.find-a-store';
    const fsBoxesShops = fsContainerId + ' .fs--boxes-shops';
    const fsSearchForm = fsContainerId + ' #searchForm';
    const fsPostalCode = fsContainerId + ' #postalCode';
    const fsCityHidden = fsContainerId + ' .city-hidden';
    const fsMapResults = fsContainerId + ' #mapResults'

    var form = $(fsSearchForm);
    var sectionInProgress = $('.internal.vitrine');
    form.submit(function (e) {
        e.preventDefault();
        $('#error-summary').html('');
        sectionInProgress.addClass('in-progress relative');
        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize(),
            success: function (data) {
                sectionInProgress.removeClass('in-progress relative');
                deleteMarkers();
                var html = $(data);
                form.find('input').blur();
                $('#nbResultsFound span')
                    .html(html.find('#nbResultsFound span').html())
                    .attr('tabindex', '-1')
                    .focus();
                $('#error-summary').html(html.find('#error-summary').html());

                if (html.find(fsMapResults).length > 0) {
                    hideMapPlaceholderToDisplayMap();
                    $('#search-map-container').removeClass('fs--landing--map').addClass('fs--search--map');
                    $(fsBoxesShops).css('visibility', 'visible');
                    $(fsBoxesShops).replaceWith(html.find(fsMapResults)[0].outerHTML);
                    if ($(fsPostalCode).val() != '' || $(fsCityHidden).val() != '') {
                        initializeMap();
                        onClickBoxShowMapMarker();
                    }
                } else {
                    $('#search-map-container').removeClass('fs--search--map').addClass('fs--landing--map');
                    $(fsBoxesShops).hide();
                }

                $(fsMapResults + ' div.store-info-wrapper .setMyStoreButton').click(onClickSetMyStore);
                $(fsMapResults + ' div.store-info-wrapper .setMyCommunicationStoreButton').click(onClickConfirmMyCommunicationStore);
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    sectionInProgress.removeClass('in-progress relative');
                }
            }
        });
    });

    $('#search-all-stores-btn').on('click', function () {
        let sectionInProgress = $('.internal.vitrine');
        sectionInProgress.addClass('in-progress relative');
        initializeMap();
        onClickBoxShowMapMarker();
        hideMapPlaceholderToDisplayMap();
        sectionInProgress.removeClass('in-progress relative');
    });

    FindStoreHelper.bindFindStore(fsContainerId);

    function onClickBoxShowMapMarker() {
        $('find-a-store .fs--box-shop').click(function () {
            let index = parseInt($(this).attr('data-store-index'));
            clickMarkerById(index);
        });
    }

    onClickBoxShowMapMarker();
}

$(document).ready(function () {
    loadGoogleMaps('initFindStore');
});
